// FISHING WATER
export const FISHING_WATERS_SIMPLIFIED_MINZOOM = 9;
export const FISHING_WATERS_SIMPLIFIED_CIRCLE_RADIUS = 5;
export const FISHING_WATERS_MINZOOM = 11;
export const FISHING_WATERS_ICON_SIZE = 0.8;
export const SELECTED_FISHING_WATER_ICON_SIZE = 0.8;

// EMPTY FISHING WATER
export const EMPTY_FISHING_WATERS_SIMPLIFIED_MINZOOM = 9;
export const EMPTY_FISHING_WATERS_SIMPLIFIED_CIRCLE_RADIUS = 4;
export const EMPTY_FISHING_WATERS_ICON_SIZE = 0.6;
export const SELECTED_EMPTY_FISHING_WATER_ICON_SIZE = 0.8;

export type FishingWatersToggleableGroup =
  | 'FISHING_WATERS'
  | 'EMPTY_FISHING_WATERS'
  | 'FORBIDDEN_FISHING_WATERS';

export const ALL_FISHING_WATERS_TOGGLEABLE_GROUPS: FishingWatersToggleableGroup[] = [
  'FISHING_WATERS',
  'EMPTY_FISHING_WATERS',
  'FORBIDDEN_FISHING_WATERS',
];
